import { $uniDebug } from "../uni-debug.module"

$uniDebug.filter("resaltar", [
  "$log",
  ($log: ng.ILogService) => (input: string, resaltado: string) => {
    $log.debug("resaltando", input, resaltado)

    return "** " + input + " **"
  }
])
